var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiemensNxV1Mini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59.842mm",
    height: "59.581mm",
    viewBox: "0 0 59.842 59.581",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.582 -48.919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.01 55.489c-1.4988 0.0078-3.1304 0.08458-4.9062 0.22583l0.10129 1.2707a26.594 26.594 0 0 1 4.083 2.4097c4.5339-0.05009 7.5555 0.54447 9.0656 1.372 0.95394 0.52275 1.3098 1.0097 1.4826 1.5606 0.0208 0.0663 0.02894 0.14713 0.04393 0.22014 0.10945 0.5336 0.06392 1.2393-0.29197 2.1999-0.80918 2.1841-3.2109 5.3139-6.8595 8.631-3.6486 3.3171-8.5105 6.8807-14.151 10.332-12.559 7.6859-22.509 10.624-26.577 11.597l-0.24288-1.5131-5.5294 4.502 6.6601 2.5451-0.27595-1.7198c4.2206-0.99852 14.844-4.0737 27.983-12.115 5.8058-3.5529 10.841-7.2315 14.732-10.769 3.8915-3.5379 6.6733-6.8767 7.8848-10.147 0.43365-1.1705 0.65564-2.3714 0.56689-3.5435-0.03522-0.46516-0.11448-0.92613-0.25632-1.3782-0.49923-1.5912-1.7102-2.915-3.3125-3.793-1.6023-0.87803-3.6034-1.4344-6.0921-1.7012-1.2444-0.13337-2.6105-0.1944-4.1093-0.18655z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.549 54.688a26.594 26.594 0 0 0-0.21084 0.01499l-3.4427 25.822-15.889-17.213a26.594 26.594 0 0 0-7.0512 17.97 26.594 26.594 0 0 0 3.7434 13.499l1.0614-0.86455 0.24133 1.5033c3.9453-0.92742 13.849-3.7949 26.579-11.585 5.6401-3.4515 10.5-7.0151 14.148-10.332 1.7393-1.5812 3.1856-3.116 4.3212-4.53a26.594 26.594 0 0 0-5.1516-6.8037 26.594 26.594 0 0 0-0.043408-0.043408 26.594 26.594 0 0 0-1.4945-1.3203 26.594 26.594 0 0 0-0.71675-0.56896 26.594 26.594 0 0 0-0.89348-0.709c-0.02211 4.83e-4 -0.04606 0.0016-0.06821 0.0021a26.594 26.594 0 0 0-3.4479-2.0516l-0.0031-0.03876a26.594 26.594 0 0 0-0.58963-0.25063 26.594 26.594 0 0 0-1.6526-0.70228 26.594 26.594 0 0 0-0.82269-0.31368 26.594 26.594 0 0 0-0.4377-0.16692l-0.0098 0.03411a26.594 26.594 0 0 0-8.1695-1.3509zm25.206 18.27c-1.0173 1.1167-2.1551 2.2483-3.4251 3.4029-3.8915 3.5379-8.9261 7.2169-14.732 10.77-12.144 7.4314-22.097 10.599-26.883 11.83a26.594 26.594 0 0 0 19.834 8.9147 26.594 26.594 0 0 0 26.594-26.594 26.594 26.594 0 0 0-1.3875-8.3235z",
    fillOpacity: 0,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.207 53.659 28.801-4.1144-4.1144 30.858z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  })), /*#__PURE__*/React.createElement("path", {
    d: "m64.256 57.641c27.718-2.2049 17.222 13.709-5.6696 27.718-16.79 10.275-29.293 12.284-29.293 12.284",
    color: "#000000",
    fillOpacity: 0,
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.258 57.764c27.718-2.2049 17.222 13.709-5.6696 27.718-16.79 10.275-29.293 12.284-29.293 12.284",
    color: "#000000",
    fillOpacity: 0,
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.301 57.611c27.718-2.2049 17.222 13.709-5.6696 27.718-16.79 10.275-29.293 12.284-29.293 12.284",
    color: "#000000",
    fillOpacity: 0,
    style: {
      InkscapeStroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiemensNxV1Mini);
export default __webpack_public_path__ + "static/media/siemens_NX_v1_mini.68743bc99becb39c228ec61325161c2b.svg";
export { ForwardRef as ReactComponent };